var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('ABreadcrumbV1',{attrs:{"items":_vm.breadcrumbs}}),_c('ALoader',{attrs:{"isLoading":_vm.api.isLoading}}),(!_vm.api.isLoading)?_c('PageAdd',{attrs:{"data":_vm.data,"callbackSuccess":_vm.callbackSuccess}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }